/**************************************************
 * Nombre:       BarraBusqueda
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, InputAdornment, TextField} from "@mui/material";
import {Search} from '@mui/icons-material'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {theme} from "../../../../Tema";

const BarraBusqueda = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: sCell ? 3 : 4,
                p: 2,

            }}
            spacing={2}
        >

            <Grid container size={{xs: 9, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <TextField
                    label={'Busqueda inteligente'}
                    slotProps={{
                        input: {
                            startAdornment: (

                                <InputAdornment position="start">
                                    <Search sx={{fill: '#000000'}}/>
                                </InputAdornment>
                            ),
                            disableUnderline: true,
                        },
                        inputLabel: {
                            sx: {marginLeft: -1}
                        }
                    }
                    }
                    placeholder={'Buscapina'}
                />
            </Grid>

            <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                {sCell ?

                    <Button fullWidth >
                        <Search/>
                    </Button>

                    :

                    <Button fullWidth>Buscar</Button>

                }

            </Grid>

        </Grid>
    )

}
export default BarraBusqueda    